import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { ACCOUNT_MANAGER_GROUP_REPORT_ID } from './accountManagerGroupReportId';

const emptyColumns = [FIELDS.ACCOUNT_MANAGER_GROUP].map(createFooterMapper(ACCOUNT_MANAGER_GROUP_REPORT_ID));

const reportFooterColumnDefinition = [...emptyColumns];

export default reportFooterColumnDefinition;
